import classNames from 'classnames'
import React from 'react'

interface Props {
  isHome?: boolean
}

const PageMain: React.FC<React.PropsWithChildren<Props>> = ({
  children,
  isHome = false,
}) => {
  return (
    <main
      className={classNames('min-h-screen', {
        'pt-[4.375rem]': !isHome,
      })}
    >
      {children}
    </main>
  )
}

export default PageMain
